import FilterParameterDto from "../datasourcemodule/FilterParameterDto";
import DataTableFieldParameterDefinitionDto from "../datasourcemodule/DataTableFieldParameterDefinitionDto";

class PathAIMappingDto {
    FieldReferenceId: number;
    TransformationLogicId: number;
    TransformationParameters: string;
    DisplayName: string;
    Description: string;
    IsSelected: boolean;
    Filters: FilterParameterDto[];
    DeclaredVariables: DataTableFieldParameterDefinitionDto[];

    constructor(
        fieldReferenceId: number,
        transformationLogicId: number,
        transformationParameters: string,
        displayName: string,
        description: string,
        isSelected: boolean = true,
        filters: FilterParameterDto[],
        declaredVariables: DataTableFieldParameterDefinitionDto[] = []
    ) {
        this.FieldReferenceId = fieldReferenceId;
        this.TransformationLogicId = transformationLogicId;
        this.TransformationParameters = transformationParameters;
        this.DisplayName = displayName;
        this.Description = description;
        this.IsSelected = isSelected;
        this.Filters = filters;
        this.DeclaredVariables = declaredVariables;
    }
}

export default PathAIMappingDto;
